import { frequencyOptions } from '../../utils/controlConstants';

/** Backend `GET /api/risk-control-mappings/rcm` `sort_by` values (see RCMListSortFields). */
export const RCM_SORT_KEY = {
  TITLE: 'title',
  SOX_CYCLE_ID: 'sox_cycle_id',
  RISK_ID: 'risk_id',
  CONTROL_ID: 'control_id',
  UPDATED_AT: 'updated_at',
};

export function formatFrequencyFilterLabel(freq) {
  return freq.charAt(0).toUpperCase() + freq.slice(1).replace('-', ' ');
}

export const RCM_CONTROL_TYPE_FILTER_OPTIONS = [
  { label: 'Control Types(All)', value: 'all' },
  { label: 'Manual', value: 'manual' },
  { label: 'Automated', value: 'automated' },
  { label: 'IT-Dependent', value: 'it-dependent' },
];

export const RCM_SIGNIFICANCE_FILTER_OPTIONS = [
  { label: 'Control Significance(All)', value: 'all' },
  { label: 'Key', value: 'key' },
  { label: 'Non-Key', value: 'non-key' },
];

export const RCM_FREQUENCY_FILTER_OPTIONS = [
  { label: 'Frequency (All)', value: 'all' },
  ...frequencyOptions.map((freq) => ({
    label: formatFrequencyFilterLabel(freq),
    value: freq,
  })),
];
